// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__GAFW_","coverWrap":"styles_coverWrap__kL9Ar","othersWrap":"styles_othersWrap__liIp1","wrongWrap":"styles_wrongWrap__TWaUi","propertiesList":"styles_propertiesList__JdWSk","listValue":"styles_listValue__hOyl1"};
module.exports.__checksum = "60146828a0b5"
